<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Id9w9K/tc-custom/9781780104461.jpg?1734289664762" alt="This image is the cover for the book Gone in a Flash, The E. J. Pugh Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gone in a Flash, The E. J. Pugh Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>“A trip to deliver their son to college pits a Texas family against several dangerous criminals. . . . A rollicking mystery.” —<i>Kirkus Reviews</i></b><br/>  <br/> After almost ruining her marriage because of her habit of involving herself in dangerous business, E.J. Pugh is determined to stay out of any sleuthing and pay attention only to her husband, children, and writing career. How hard can it be?<br/>  <br/> But through no fault of their own, E.J. and Willis are plunged into another crisis when someone hides a black satchel in Willis’ truck, apparently while they were using it to cart their son—and all his stuff—to the University of Texas at Austin. And their foster daughter, Alicia, finding no ID inside, decides to make it her new backpack.<br/>  <br/> When Alicia suddenly disappears, along with the satchel, E.J. and Willis are beside themselves, and E.J. has no choice but to get involved in another mystery, possibly connected to a murder in Austin—and this time, solving it is more urgent than ever . . .<br/>  <br/> “Plenty of red herrings and amusing characters who could have been friends of Stephanie Plum.” —<i>Kirkus Reviews</i><br/>  <br/> “One of today’s finest mystery writers.” —Carolyn Hart<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Rogers Cooper
      </h2>
      
      <p class="authorDescription body article">Susan Rogers Cooper is half-Texan, half-Yankee, and now lives with her family in a small town in central Texas. She is the author of the ‘E.J. Pugh’ series and the ‘Milt Kovak’ series, amongst other books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Severn House
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a737cba8